import { UrlCluster } from '../urlClusters/types';
import { ServiceableUrl, ServiceableUrlTableRecord } from './types';

export function getServiceableUrlsTableData(urls: ServiceableUrl[], urlClusters: UrlCluster[]): ServiceableUrlTableRecord[] {
    // transform list to object for faster access
    const clustersMap = urlClusters.reduce((acc, cluster) => {
        acc[cluster.guid] = cluster;
        return acc;
    }, {} as Record<string, UrlCluster>);

    return urls.map((url, idx) => ({
        key: url.guid,
        websiteGuid: url.w_guid,
        clusterGuid: url.cluster_guid,
        clusterLabel: clustersMap[url.cluster_guid]?.title || '',
        idx: idx + 1,
        url: url.url,
        seoScore: url.on_page_seo?.score,
        statusCode: url.status_code,
        checks: url.on_page_seo ? { passed: url.on_page_seo.passed, warning: url.on_page_seo.warning, failed: url.on_page_seo.failed } : null,
        lastAnalyzed: url.on_page_seo?.c_at ? url.on_page_seo.c_at.split('T')[0] : null,
    }));
}
